<template>
  <div>
      <v-row>
        <v-col>
          <v-text-field
            v-model="$attrs.value.name"
            outlined
            label="*ชื่อสินค้าใน tiktokk"
            :rules="[validators.required, validators.maxLengthValidator($attrs.value.name, 250), validators.minLengthValidator($attrs.value.name, 25)]"
            hide-details="auto"
            dense
            counter="250"
            :disabled="$store.getters['app/GET_APP_MODE'] == 'read'"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-textarea

            v-model="$attrs.value.description"
            outlined
            label="* คำอธิบายใน tiktokk"
            :rules="[validators.required, validators.maxLengthValidator($attrs.value.description, 2000)]"
            hide-details="auto"
            dense
            counter="2000"
            :disabled="$store.getters['app/GET_APP_MODE'] == 'read'"
          ></v-textarea>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-autocomplete
            :items="categoryList"
            label="* เลือกหมวดหมู่ ของ tiktokk"
            outlined
            v-model="$attrs.value.category_id"
            item-text="full_display_name"
            item-value="id"
            dense
            :rules="[validators.required]"
            :disabled="categoryLoading || $store.getters['app/GET_APP_MODE'] == 'read' || !!$attrs.value.tiktok_product_id"
            :loading="categoryLoading"
            clearable
            >
            </v-autocomplete>
        </v-col>
      </v-row>

      <!-- Variable Product Section -->
      <template v-if="parentData.isVariable">
        <v-row v-if="!$attrs.value.tiktok_product_id">
          <v-col cols="12">
            <tiktok-mapping-table
            :aooAttributes="parentData.attributes"
            :tiktokAttributes="salesAttributes"
            v-model="$attrs.value.sale_attributes"
            ></tiktok-mapping-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <tiktok-model-table :attributes="parentData.attributes" v-model="$attrs.value.variations"></tiktok-model-table>
          </v-col>
        </v-row>
      </template>
      <!-- Simple Product Section -->
      <v-row v-else>
        <v-col>
          <v-text-field
            v-model.number="$attrs.value.original_price"
            outlined
            label="*ราคาปกติใน tiktok"
            placeholder="0.00"
            :rules="[validators.required, validators.numberValidator]"
            hide-details="auto"
            dense
            type="number"
            :disabled="$store.getters['app/GET_APP_MODE'] == 'read'"
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- Product Attribute Section -->
      <template v-if="$attrs.value.attributes && !attributeLoading">
        <v-row>
          <v-col>
            <v-divider></v-divider>
          </v-col>
        </v-row>
        <v-row
        v-for="(attribute, attribute_index) in productAttributes"
        :key="attribute.id"
        >
          <v-col>
            <v-text-field
              v-if="attribute.is_customizable && !attribute.values"
              :id="attribute.id"
              v-model="attribute.value"
              outlined
              :label="attribute.is_requried ? '*' : '' + attribute.name"
              :rules="getAttributeRule(attribute)"
              hide-details="auto"
              dense
              :disabled="$store.getters['app/GET_APP_MODE'] == 'read'"
            ></v-text-field>
            <v-autocomplete
              v-if="attribute.values"
              :id="attribute.id"
              v-model="attribute.value"
              outlined
              :label="attribute.is_requried ? '*' : '' + attribute.name"
              :rules="getAttributeRule(attribute)"
              :items="attribute.values"
              item-text="name"
              item-value="id"
              hide-details="auto"
              dense
              :multiple="attribute.is_multiple_selection"
              :chips="attribute.is_multiple_selection"
              :tags="attribute.is_customizable"
              :disabled="$store.getters['app/GET_APP_MODE'] == 'read'"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
      </template>
      <v-progress-linear
        v-else-if="attributeLoading"
        indeterminate
        color="primary"
        class="mt-4"
      ></v-progress-linear>
  </div>
</template>
<script>
import {
  integerValidator,
  lengthValidator,
  maxLengthValidator,
  maxValueValidator,
  minLengthValidator,
  minValueValidator,
  numberValidator,
  required,
  requiredIf,
} from '@core/utils/validation'
import TiktokModelTable from './TiktokModelTable.vue'
import TiktokMappingTable from './TiktokMappingTable.vue'
import { asyncGet } from '@/helpers/asyncAxios'
import errorParser from '@/plugins/errorparser'
export default {
  props: ['parentData'],
  data() {
    return {
      categoryList: [],
      categoryRuleList: null,
      categoryLoading: false,
      categoryRuleLoading: false,
      attributeLoading: false,
      sizechartLoading: false,
      validators: {
        required,
        requiredIf,
        lengthValidator,
        minLengthValidator,
        maxLengthValidator,
        integerValidator,
        numberValidator,
        minValueValidator,
        maxValueValidator,
      },
    }
  },
  watch: {
    '$attrs.value.tiktok_salechannel_id': function (value, oldValue) {
      this.$attrs.value.category_id = null
      this.$attrs.value.brand_id = null

      if (!value) {
        this.categoryList = []
        return
      }

      this.getCategoryList()
    },
    '$attrs.value.category_id': function (value, oldValue) {
      if (!value) {
        this.brandList = []
        return
      }

      this.getCategoryRuleList(value)
      this.getAttributeList(value)
    },
    isSizeChartRequired(value) {
      if (!value) return

      if (this.$store.getters['app/GET_APP_MODE'] != 'create') return

      this.$root.showCommonDialog(
        'โปรดทราบ',
        'สินค้าประเภทนี้ไม่สามารถสร้างผ่านช่องทางนี้ได้ด้วยข้อจำกัดจากทาง Tiktok โปรดสร้างสินค้าที่ tiktok แล้วใส่ sku ให้ตรงกันกับในระบบ ระบบจะทำการเชื่อมต่อโดยอัตโนมัติในกรณีที่มีออเดอร์เข้ามา',
      )
    },
    isCertificateRequired(value) {
      if (!value) return

      if (this.$store.getters['app/GET_APP_MODE'] != 'create') return

      this.$root.showCommonDialog(
        'โปรดทราบ',
        'สินค้าประเภทนี้ไม่สามารถสร้างผ่านช่องทางนี้ได้ด้วยข้อจำกัดจากทาง Tiktok โปรดสร้างสินค้าที่ tiktok แล้วใส่ sku ให้ตรงกันกับในระบบ ระบบจะทำการเชื่อมต่อโดยอัตโนมัติในกรณีที่มีออเดอร์เข้ามา',
      )
    },
  },
  computed: {
    isSizeChartRequired() {
      if (!this.categoryRuleList) return false

      return this.categoryRuleList.size_chart.is_required
    },
    isCertificateRequired() {
      if (!this.categoryRuleList) return false

      return this.categoryRuleList.product_certifications.is_required
    },
    productAttributes() {
      if (!this.$attrs.value.attributes) return null

      return this.$attrs.value.attributes.filter(item => item.type == 'PRODUCT_PROPERTY')
    },
    salesAttributes() {
      console.log('called ?')
      if (!this.$attrs.value.attributes) return null

      return this.$attrs.value.attributes.filter(item => item.type == 'SALES_PROPERTY')
    },
  },
  mounted() {
    if (!this.$attrs.value.original_price && !this.$attrs.isVariable)
      this.$attrs.value.original_price = this.parentData.defaultPrice

    if (!this.$attrs.value.name) this.$attrs.value.name = this.parentData.name

    if (!this.$attrs.value.variations)
      this.$attrs.value.variations = JSON.parse(JSON.stringify(this.parentData.variations))

    this.getCategoryList()

    if (this.$attrs.value.category_id) {
      this.getCategoryRuleList(this.$attrs.value.category_id)
      this.getAttributeList(this.$attrs.value.category_id)
    }
  },
  methods: {
    getAttributeRule(attribute) {
      const rules = []
      if (attribute.is_requried) rules.push(this.validators.required)

      const that = this
      if (attribute.requirement_conditions) {
        attribute.requirement_conditions.forEach(item => {
          if (item.condition_type == 'VALUE_ID_MATCH') {
            const targetAttribute = that.$attrs.value.attributes.find(search => search.id == item.attribute_id)

            if (!targetAttribute) return

            rules.push(that.validators.requiredIf(attribute.value, targetAttribute.value, item.attribute_value_id))
          }
        })
      }

      return rules
    },
    async getCategoryList() {
      try {
        this.categoryLoading = true

        const response = await asyncGet('/product/' + this.$attrs.value.tiktok_salechannel_id + '/tiktok/categories')

        this.categoryList = this.getLeafCategories(response)
      } catch (error) {
        this.$root.showCommonDialog('มีปัญหา', errorParser(error))
      }

      this.categoryLoading = false
    },
    async getCategoryRuleList(category_id) {
      try {
        this.categoryRuleLoading = true

        const response = await asyncGet(
          '/product/' + this.$attrs.value.tiktok_salechannel_id + '/tiktok/categories/' + category_id + '/rules',
        )

        this.categoryRuleList = response
      } catch (error) {
        this.$root.showCommonDialog('มีปัญหา', errorParser(error))
      }

      this.categoryRuleLoading = false
    },
    async getAttributeList(category_id) {
      try {
        this.attributeLoading = true

        const response = await asyncGet(
          '/product/' + this.$attrs.value.tiktok_salechannel_id + '/tiktok/categories/' + category_id + '/attributes',
        )

        //this.$attrs.value.attributes = []

        const attributes = []

        const original = this.$attrs.value.attributes ? this.$attrs.value.attributes : []
        response.forEach(element => {
          let searchAttribute = original.find(attribute => attribute.id == element.id)

          if (!searchAttribute) {
            attributes.push({
              ...element,
              value: null,
            })
          } else {
            attributes.push({
              ...searchAttribute,
              ...element,
            })
          }
        })

        //this.$attrs.value.attributes = attributes
        this.$set(this.$attrs.value, 'attributes', attributes)
      } catch (error) {
        this.$root.showCommonDialog('มีปัญหา', errorParser(error))
      }

      this.attributeLoading = false
    },
    getLeafCategories(categories) {
      const idToCategory = {}

      // Create a lookup table for quick parent access
      categories.forEach(category => {
        idToCategory[category.id] = category
      })

      // Build the full path (breadcrumb) from root to leaf
      function getFullDisplayName(category) {
        let name = category.local_name
        let parentId = category.parent_id

        while (parentId !== '0' && idToCategory[parentId]) {
          const parent = idToCategory[parentId]
          name = `${parent.local_name} > ${name}`
          parentId = parent.parent_id
        }

        return name
      }

      return categories
        .filter(category => category.is_leaf && category.permission_statuses.includes('AVAILABLE'))
        .map(category => ({
          ...category,
          full_display_name: getFullDisplayName(category),
        }))
    },
  },
  components: {
    TiktokModelTable,
    TiktokMappingTable,
  },
}
</script>
